import { createContext } from 'react';

import { Filter } from '@pkg/classes';
import { noop } from '@pkg/utils';

import { type FilterContextDescriptor } from './types';

export const DEFAULT_FILTER_DATA = new Filter();
export const FilterContext = createContext<FilterContextDescriptor>([DEFAULT_FILTER_DATA, noop]);
